import { COLORS } from '../../common/utils/icon/constants';
import { getIcon } from '../../common/utils/icon/icon';
const getStyles = notNeutral => `
  height: auto;
  ${notNeutral && 'margin-top: -7%'};
  width: ${notNeutral ? '63%' : '100%'};
`;
const configuration = {
  colors: [COLORS.green, COLORS.white],
  getStyles,
  id: 'baggage-service'
};
export default type => getIcon({
  ...configuration,
  type
});
//# sourceMappingURL=icon.js.map